import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { warningSignsChapter } from '@/learning-paths/incode/warning-signs/chapter'

export const Route = createFileRoute('/_auth/learning-journeys/warning-signs')({
  component: WarningSignsRoute,
})

function WarningSignsRoute() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({
      to: '/learning-journeys/scam-fundamentals',
      search: { invitationcode: undefined, __clerk_ticket: undefined },
    })
  }

  return (
    <SlideWizard
      chapter={warningSignsChapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
